<template functional>
	<div class="mega-menu-department full-width">
		<div class="flex">
			<div class="flex-adapt">
				<ul class="mega-menu-subdepartments">
					<li
						v-for="dep1 in props.menuItem.children"
						:key="dep1.id"
					>
						<a class="fs-14 bold" :href="dep1.url">
							{{ dep1.name }}
						</a>
						<ul v-if="dep1.children" class="mega-menu-categories">
							<li
								v-for="dep2 in dep1.children"
								:key="dep2.id"
							>
								<a :href="dep2.url" class="block fs-12">
									{{ dep2.name }}
								</a>
							</li>
							<li v-if="dep1.hasShowMoreLink">
								<a class="show-more-link fs-12" :href="dep1.url">
									<span class="text">More</span>
									<span class="icon icon-arrow-forward" aria-hidden="true"></span>
								</a>
							</li>
						</ul>
					</li>
				</ul>
				<div class="shop-all-btn-wrapper">
					<ui-button
						color="soft-blue-outline block"
						class="ui-btn-full"
						size="sm"
						:href="props.menuItem.url"
					>
						Shop All {{ props.menuItem.name }}
					</ui-button>
				</div>
			</div>
			<a
				v-if="props.menuItem.bannerImageUrl"
				:href="props.menuItem.bannerLinkUrl"
				class="mega-menu-department-image hide-desktop-min"
			>
				<img :src="props.menuItem.bannerImageUrl" :alt="props.menuItem.name" />
			</a>
		</div>
	</div>
</template>

<script>
import UiButton from 'Src/js/components/UiButton.vue';
import Vue from 'vue';
Vue.use(UiButton);
export default {
	components: { UiButton },
	name: 'MegaMenuDepartment',
	props: {
		menuItem: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="less">
.mega-menu-department {
	background-color: #FFF;
	top: 0; bottom: 0; left: 100%;
	padding: 20px;
	position: absolute;
	min-height: 0;
	max-width: calc(~"100vw - 240px");
	width: 1240px;
	a {
		text-decoration: none;
		&:hover {
			text-decoration: underline;
		}
	}
}

ul.mega-menu-subdepartments {
	column-count: 4;
	overflow: hidden;
	height: 540px;
	> li {
		break-inside: avoid-column;
		display: table;
		max-width: 190px;
		page-break-inside: avoid;
		width: 100%;
	}
}

ul.mega-menu-categories {
	margin-top: 3px;
	padding-bottom: 20px;
	a {
		color: #000;
		line-height: 1.4em;
		padding: 2px 0;
	}
}

.mega-menu-department-image img {
	width: 300px;
}

.shop-all-btn-wrapper {
	flex: 0 0 42px;
	a.ui-btn {
		max-width: 100%;
		width: 100%;
	}
}
</style>